import axiosInstance from "../utils/axios"
import { parseFilenameFromDisposition } from "../utils/download"

export const registrationService = {
  getById: async (id) => {
    const { data } = await axiosInstance.get(`/registration/${id}`)
    return data
  },
  reject: async (id, body) => {
    const { data } = await axiosInstance.post(`/registration/reject/${id}`, body)
    return data
  },
  accept: async (id, body) => {
    const { data } = await axiosInstance.post(`/registration/accept/${id}`, body)
    return data
  },
  getRejectedData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/rejected`, { params })
    return data
  },
  getFinishData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/finish`, { params })
    return data
  },
  getRejectedDataById: async (id) => {
    const { data } = await axiosInstance.get(`/registration/rejected/${id}`)
    return data
  },
  getAcceptedDataById: async (id) => {
    const { data } = await axiosInstance.get(`/registration/accepted/${id}`)
    return data
  },
  changeSurveyor: async (id, body) => {
    const { data } = await axiosInstance.post(`/registration/${id}/change-surveyor`, body)
    return data
  },
  getDataForSurveyor: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/surveyor`, { params })
    return data
  },
  getNeedConfirmationData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/need-confirmation`, { params })
    return data
  },
  getRCCData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/rcc`, { params })
    return data
  },
  getProcessData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/process`, { params })
    return data
  },
  getAllData: async (params = {}) => {
    const { data } = await axiosInstance.get(`/registration/all`, { params })
    return data
  },
  exportAllData: async (params = {}) => {
    const response = await axiosInstance.get(`/registration/all/export`, {
      params,
      responseType: 'blob'
    })
    const disposition = response.headers["content-disposition"];
    const filename = parseFilenameFromDisposition(disposition) || "sambungan-baru-export.xlsx";
    return { blob: response.data, filename };
  },
  store: async (body) => {
    const { data } = await axiosInstance.postForm(`/registration`, body)
    return data
  },
  checkSurveyorAB: async (body) => {
    const { data } = await axiosInstance.post(`/registration/check-surveyor-ab`, body)
    return data
  },
  downloadRegistrationData: async (id) => {
    const response = await axiosInstance.get(`/registration/export/${id}`)

    const contentType = response.headers['content-type'];
    const contentDisposition = response.headers['content-disposition'];

    // Extract filename from content-disposition header
    let filename = 'downloaded-file';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch.length === 2) filename = filenameMatch[1];
    }

    // Trigger download
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    return { success: true, filename };
  },
  exportOnProgressRegistration: async (params) => {
    const response = await axiosInstance.get(`/registration/process/export`, {
      params,
      responseType: 'blob'
    })

    const disposition = response.headers["content-disposition"];
    const filename = parseFilenameFromDisposition(disposition) || "sambungan-baru-export.xlsx";
    return { blob: response.data, filename };
  },
}